export default "__VITE_ASSET__203105ad__"